import { createAction } from 'redux-actions'

const CHANGE_LOCATION = 'CHANGE_LOCATION'
const RESET_PARTICIPANTS = 'RESET_PARTICIPANTS'
const SET_PARTICIPANT = 'SET_PARTICIPANT'
const SET_ACTIVE_PARTICIPANTS = 'SET_ACTIVE_PARTICIPANTS'
const SET_ARCHIVED_PARTICIPANTS = 'SET_ARCHIVED_PARTICIPANTS'
const SET_PARTICIPANT_DETAILS = 'SET_PARTICIPANT_DETAILS'
const SET_PARTICIPANT_SESSIONS = 'SET_PARTICIPANT_SESSIONS'
const SET_PARTICIPANT_SESSION_DETAILS = 'SET_PARTICIPANT_SESSION_DETAILS'
const SET_AVAILABLE_EXERCISES = 'SET_AVAILABLE_EXERCISES'

const actions = {
    changeLocation: createAction(CHANGE_LOCATION),
    resetParticipants: createAction(RESET_PARTICIPANTS),
    setParticipant: createAction(SET_PARTICIPANT),
    setActiveParticipants: createAction(SET_ACTIVE_PARTICIPANTS),
    setArchivedParticipants: createAction(SET_ARCHIVED_PARTICIPANTS),
    setParticipantDetails: createAction(SET_PARTICIPANT_DETAILS),
    setParticipantSessions: createAction(SET_PARTICIPANT_SESSIONS),
    setParticipantSessionDetails: createAction(SET_PARTICIPANT_SESSION_DETAILS),
    setAvailableExercises: createAction(SET_AVAILABLE_EXERCISES)
}

const types = {
    CHANGE_LOCATION,
    RESET_PARTICIPANTS,
    SET_PARTICIPANT,
    SET_ACTIVE_PARTICIPANTS,
    SET_ARCHIVED_PARTICIPANTS,
    SET_PARTICIPANT_DETAILS,
    SET_PARTICIPANT_SESSIONS,
    SET_PARTICIPANT_SESSION_DETAILS,
    SET_AVAILABLE_EXERCISES
}

export { actions, types }



// WEBPACK FOOTER //
// ./src/store/actions/participants.js